module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/font-awesome/fonts/fontawesome-webfont.eot
// module id = ../../../../../src/assets/fonts/font-awesome/fonts/fontawesome-webfont.eot
// module chunks = styles